import { useContext } from 'react';
import { NewCommunicationActionsContext } from './NewCommunicationContext';

export const useNewCommunicationActions = () => {
  const context = useContext(NewCommunicationActionsContext);

  if (!context) {
    throw new Error('useNewCommunicationActions must be used within a NewCommunicationProvider');
  }

  return context;
};
